import {
  gmail,
  linkedinLink as linkLinkedin,
  linkedinLogin as loginLinkedin,
  linkedinRegister as registerLinkedin,
  outlook,
} from "api/oauth";

export const linkedinLogin = (code) => ({
  type: "USER_LOGIN_LINKEDIN",
  payload: loginLinkedin(code),
});

export const linkedinLink = (code) => ({
  type: "USER_LINK_LINKEDIN",
  payload: linkLinkedin(code),
});

export const linkedinRegister = (code) => ({
  type: "USER_REGISTER_LINKEDIN",
  payload: registerLinkedin(code),
});

export const gmailAuthenticate = (code) => ({
  type: "OAUTH_AUTHENTICATE_GMAIL",
  payload: gmail(code),
});

export const outlookAuthenticate = (code) => ({
  type: "OAUTH_AUTHENTICATE_OUTLOOK",
  payload: outlook(code),
});
